var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIndustry(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_192_412)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4399 7.5H12.4999C13.8783 7.5 14.9999 6.37833 14.9999 5V2.5C14.9999 1.12167 13.8783 0 12.4999 0H7.49994C6.12161 0 4.99994 1.12167 4.99994 2.5V5C4.99994 6.37833 6.12161 7.5 7.49994 7.5H7.66828L9.19661 8.8475C9.43828 9.06083 9.74078 9.1675 10.0433 9.1675C10.3416 9.1675 10.6399 9.0625 10.8749 8.85417L12.4399 7.50083V7.5ZM4.58328 15C6.19161 15 7.49994 13.6917 7.49994 12.0833C7.49994 10.475 6.19161 9.16667 4.58328 9.16667C2.97494 9.16667 1.66661 10.475 1.66661 12.0833C1.66661 13.6917 2.97494 15 4.58328 15ZM12.4999 12.0833C12.4999 13.6917 13.8083 15 15.4166 15C17.0249 15 18.3333 13.6917 18.3333 12.0833C18.3333 10.475 17.0249 9.16667 15.4166 9.16667C13.8083 9.16667 12.4999 10.475 12.4999 12.0833ZM4.58328 15.8333C2.55494 15.8333 0.734944 17.055 0.0524445 18.8742C-0.0433889 19.13 -0.00755554 19.4167 0.147444 19.6417C0.304111 19.8667 0.559111 20 0.832444 20H8.33244C8.60578 20 8.86161 19.8658 9.01744 19.6417C9.17328 19.4167 9.20828 19.13 9.11244 18.8742C8.43078 17.055 6.60994 15.8333 4.58161 15.8333H4.58328ZM19.9474 18.8742C19.2658 17.055 17.4449 15.8333 15.4166 15.8333C13.3883 15.8333 11.5683 17.055 10.8858 18.8742C10.7899 19.13 10.8258 19.4167 10.9808 19.6417C11.1374 19.8667 11.3924 20 11.6658 20H19.1658C19.4391 20 19.6949 19.8658 19.8508 19.6417C20.0066 19.4167 20.0416 19.13 19.9458 18.8742H19.9474Z",
    fill: "url(#paint0_linear_192_412)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_192_412",
    x1: 9.99922,
    y1: 0,
    x2: 9.99922,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91C04A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009EDB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_192_412"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustry);
export default __webpack_public_path__ + "static/media/industry.bb9506d5ba89c51dbcd5f5b2fe2e648d.svg";
export { ForwardRef as ReactComponent };